import React, { FC } from 'react';
import styled from 'styled-components';
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles';
import { FileCopyOutlined } from '@material-ui/icons';
import { FileMessage } from 'models/twilio';
import { COLORS } from 'components/twilio/constants';
import getFileSizeText from 'components/chat/utils/getFileSizeText';
import ColoredMaterialIcon, { ColoredMaterialIconProps } from '../styled/ColoredMaterialIcon';
import { ChatSubtitleText, ChatTitleSubtitleGroupContainer, ChatTitleText } from '../CommonChatDisplayComponents';

const FileDetail = styled(ChatTitleSubtitleGroupContainer)`
  width: 100%;
`;

const FileName = styled(ChatTitleText)`
  font-weight: normal;
  max-width: 100%;
`;

const FileSize = styled(ChatSubtitleText)`
  color: ${COLORS.LIGHT_GREY};
`;

const FileMessageContainer = styled.a`
  text-decoration: none;
  background-color: ${COLORS.WHITE};
  padding: 16px;
  margin: 10px 0;
  display: flex;
  border-radius: 4px;
  border: 1px solid ${COLORS.GREY_H};
  align-items: center;
  justify-content: flex-start;
`;

const fileIconDefaultProps: ColoredMaterialIconProps = {
  Icon: FileCopyOutlined,
  color: COLORS.SKY_BLUE,
};

const fileMessageIconOverrides: CreateCSSProperties = {
  width: '24px',
  height: '24px',
  marginRight: '10px',
};

const TwilioFileMessage: FC<{ file: FileMessage }> = ({ file }) => (
  <FileMessageContainer
    href={file?.url}
    target="_blank"
    download
    rel="noopener noreferrer"
  >
    <ColoredMaterialIcon {...fileIconDefaultProps} overrides={fileMessageIconOverrides} />
    <FileDetail>
      <FileName>{file?.name}</FileName>
      {file?.size && <FileSize>{getFileSizeText(file.size)}</FileSize>}
    </FileDetail>
  </FileMessageContainer>
);

export default TwilioFileMessage;
